import React, { useState } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import TextInput from '../../../common/TextInput/';
import { verificationCodeRequested } from './../actions';
import './styles.scss';

function OtpForm({ onOtpSet }) {
    const [otp, setOtp] = useState('');

    const buttonText = 'Next';
    return (
        <>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    onOtpSet(otp);
                }}
            >
                <div className="filter-form">
                    <h2 className="mb-24 loginTitle">Verify Email</h2>
                    <div className="signin-seperator">
                        <div className="signin-divider"></div>
                    </div>
                    <div className="customInput">
                        <h3 className="titleStyle2">One Time Password</h3>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text icon2-mail"></span>
                            </div>
                            <TextInput
                                type="text"
                                onChange={(event) => setOtp(event.target.value)}
                                title="Must be a six digit number"
                                value={otp}
                                placeholder={'otp'}
                                required="required"
                            />
                        </div>
                    </div>
                    <button
                        disabled={!otp || otp.length != 6}
                        type="submit"
                        className="btn btn-custom btn-block"
                    >
                        {buttonText}
                    </button>
                </div>
            </form>
        </>
    );
}

OtpForm.propTypes = {
    // function to be called when form is submitted
    onOtpSet: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        onOtpSet: (otp) => dispatch(verificationCodeRequested(otp)),
    };
};

const ConnectedOtpForm = connect(null, mapDispatchToProps)(OtpForm);

export default ConnectedOtpForm;
